export default __webpack_public_path__ + "static/media/Skeleton-3D-Model-Rigged-00.0a49dacc.jpg";